export default __webpack_public_path__ + "static/media/spitchLogo.cd81bc7d.svg";